module.exports = __webpack_public_path__ + "src/assets/games/11/395.jpg";